import { render } from "./DateRules.vue?vue&type=template&id=4282501f&scoped=true"
import script from "./DateRules.vue?vue&type=script&lang=js"
export * from "./DateRules.vue?vue&type=script&lang=js"

import "./DateRules.vue?vue&type=style&index=0&id=4282501f&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4282501f"]])

export default __exports__